/* Valkyrie's Kiss — shared behaviour (loaded once; guarded so re-includes are no-ops) */
(function () {
  if (window.__vkmInit) return;
  window.__vkmInit = true;

  function initReveal() {
    var els = document.querySelectorAll('.vkm .reveal:not(.in)');
    if (!els.length) return;
    var reduce = window.matchMedia('(prefers-reduced-motion:reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initFaq() {
    document.querySelectorAll('.vkm .faq-q').forEach(function (btn) {
      if (btn.dataset.vkmBound) return;
      btn.dataset.vkmBound = '1';
      btn.addEventListener('click', function () {
        var item = btn.parentElement, panel = item.querySelector('.faq-a');
        var open = item.classList.toggle('open');
        btn.setAttribute('aria-expanded', open);
        panel.style.maxHeight = open ? panel.scrollHeight + 'px' : null;
      });
    });
  }

  function boot() { initReveal(); initFaq(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Re-run inside the theme editor when a section is added/reordered
  document.addEventListener('shopify:section:load', boot);
})();
